import { VERTICAL_EMBED_TYPE } from "./types";
import { nodeViewRenderers } from "./viewer/nodeViewRenderers-loadable";
const pluginVerticalEmbed = (config) => {
  return {
    config: { ...config },
    type: VERTICAL_EMBED_TYPE,
    nodeViewRenderers
  };
};
export {
  pluginVerticalEmbed
};
//# sourceMappingURL=viewer-loadable.js.map
